export default function ChartFrame({ label, summary = [], children }) {
  return (
    <figure className="chart-frame">
      <figcaption className="sr-only">{label}</figcaption>
      <div className="chart-visual" aria-hidden="true">{children}</div>
      {summary.length > 0 && (
        <ul className="sr-only">
          {summary.map((item) => (
            <li key={item.label}>{item.label}: {item.value}</li>
          ))}
        </ul>
      )}
    </figure>
  );
}
